<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vgQmHQ/tc-custom/9781466826052.jpg?1724432671799" alt="This image is the cover for the book Singularity's Ring"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Singularity's Ring
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The debut novel from a exciting new voice in SF—about what happens after ninety percent of humanity leaves Earth </b><br/><br/>There is an artificial ring around the Earth and it is empty after the Singularity. Either all the millions of inhabitants are dead, or they have been transformed into energy beings beyond human perception. Earth's population was reduced by ninety percent. Human civilization on Earth is now recovering from this trauma and even has a vigorous space program. <br/><br/>Apollo Papadopulos is in training to become the captain of the starship <i>Consensus</i>. Apollo is a unique individual in that he/she/it is not an individual at all, but five separate teenagers who form a new entity. Strom, Meda, Quant, Manuel, and Moira are a pod, as these kinds of personalities are called, genetically engineered to work as one and to be able to communicate non-verbally. As a rare quintet, much relies on the successful training of Apollo, but as more accidents occur, the pod members struggle just to survive. <br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Melko
      </h2>
      
      <p class="authorDescription body article"><P><B>Paul Melko</B> lives in Ohio. <I>Singularity's Ring</I> is his first novel.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27472a24